function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { FaChevronRight } from 'react-icons/fa';
var _MobileMenuItem = function MobileMenuItem(_ref) {
  var item = _ref.item,
    items = _ref.items,
    _ref$depth = _ref.depth,
    depth = _ref$depth === void 0 ? 0 : _ref$depth,
    _onClick = _ref.onClick,
    selected = _ref.selected;
  var navigate = useNavigate();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var _id = item._id,
    title = item.title,
    children = item.children;
  var _useParams = useParams(),
    app = _useParams.app;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "mm__item"
  }, /*#__PURE__*/React.createElement("div", {
    className: ['mm-item__parent', (selected === null || selected === void 0 ? void 0 : selected._id) === _id ? 'mm-item__parent-expanded' : '', depth > 0 ? 'mm-item__child' : '', depth === 2 ? 'mm-item__sub-child' : ''].join(' '),
    onClick: function onClick() {
      _onClick(item);
      if (children) setOpen(!open);
      navigate("/".concat(app, "/mobile-navigation/").concat(_id));
    },
    id: 'mm_parent_' + _id
  }, /*#__PURE__*/React.createElement("p", null, depth === 1 && /*#__PURE__*/React.createElement(FaChevronRight, null), title))), children && open && items.filter(function (x) {
    return x.parentID === _id;
  }).sort(function (a, b) {
    return a.slot - b.slot;
  }).map(function (x) {
    return /*#__PURE__*/React.createElement(_MobileMenuItem, {
      item: x,
      items: items,
      onClick: function onClick(x) {
        return _onClick(x);
      },
      depth: depth + 1,
      selected: selected,
      key: x._id
    });
  }));
};
export default _MobileMenuItem;